import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';
import React from 'react';
import ExpandySection, {
  Props as ExpandySectionProps,
} from 'components/ExpandySection';
import styles from './expandy-section.module.css';
import { ensureKey } from '@daymade/common-lib/types';

const ComponentPreview = () => {
  return (
    <AboutUsModule background="white">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Expandy Section</h3>
        <p>
          A smoothly opening and closing section that provides no styling at
          all. The preview below shows how it can be styled by providing{' '}
          <strong>
            {ensureKey<ExpandySectionProps>(null, 'containerClassName')}
          </strong>{' '}
          and{' '}
          <strong>
            {ensureKey<ExpandySectionProps>(null, 'expandedContainerClassName')}
          </strong>{' '}
          props to the component.
        </p>
        <ExpandySection
          containerClassName={styles.expandySection1}
          expandedContainerClassName={styles.expandySection1expanded}
          headerContent={
            <div className={styles.expandySection1header}>
              I start closed{' '}
              <span className={styles.expandySection1icon}>▸</span>
            </div>
          }
        >
          <div className={styles.expandySection1content}>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
          </div>
        </ExpandySection>
        <br />
        <ExpandySection
          containerClassName={styles.expandySection1}
          expandedContainerClassName={styles.expandySection1expanded}
          headerContent={
            <div className={styles.expandySection1header}>
              I started opened{' '}
              <span className={styles.expandySection1icon}>▸</span>
            </div>
          }
          initiallyExpanded
        >
          <div className={styles.expandySection1content}>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
          </div>
        </ExpandySection>

        <p>
          The expandy section button can also be aligned to the right, with the
          content opening at full width
        </p>
        <ExpandySection
          containerClassName={styles.expandySectionRightAlignment}
          expandedContainerClassName={
            styles.expandySectionRightAlignmentExpanded
          }
          expandButtonAlignment="right"
          headerContent={
            <div className={styles.expandySectionRightAlignmentHeader}>
              Right aligned{' '}
              <span className={styles.expandySection1icon}>▸</span>
            </div>
          }
        >
          <div className={styles.expandySectionRightAlignmentContent}>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
            <p>This text is inside the container</p>
          </div>
        </ExpandySection>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Expandy Section',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
